import React from 'react';
import SyncUsersView from "./SyncUsersView";
import TaskBase from '../../ws/TaskBase';
import { LoadingView } from "@cuatroochenta/co-admin-react-library";

interface ApiResponse {
    message: string;
    status: string;
}

interface state {
    loading: boolean;
    error: Error | null;
}

class SyncUsersContainer extends React.Component {

    public state: state = { loading: false, error: null };

    onClick = () => {
        this.setState({loading: true});
        new TaskBase().syncUsers()
        .then((response: ApiResponse) => {
            if(response){
                this.setState({loading: false});
                console.log("response: " + JSON.stringify(response))
            } else{
                this.setState({loading: false});
                console.log("no hay respuesta")
            }
            
        })
        .catch((error: Error) => {
            this.setState({loading: false});
            this.setState({error: error});
        })
    }

    public render() {
        const { error } = this.state;
        if (this.state.loading) {
            return <LoadingView loading={this.state.loading} />;
        }

        if (error) {
            return <div>Error: {error.message}</div>;
        }

        return <SyncUsersView onClick={this.onClick}/>;
    }

}

export default SyncUsersContainer;